import { Button as ButtonPrimitive } from "@base-ui/react/button";
import { cn } from "./cn";
import { buttonRecipe } from "./recipes";
import { cva, type VariantProps } from "class-variance-authority";

// The console's variant and size names, mapped onto the design system's looks
// (@nt/ui/recipes): default is the forest pill, outline and secondary the
// white card-ring pill, destructive the soft danger tint the console always
// used. Sizes follow the density tier — the console is compact, so the
// default control is 36px (44px on a touch screen).
const buttonVariants = cva(buttonRecipe.base, {
  variants: {
    variant: {
      default: buttonRecipe.look.primary,
      outline: buttonRecipe.look.secondary,
      secondary: buttonRecipe.look.secondary,
      ghost: buttonRecipe.look.ghost,
      destructive: buttonRecipe.look["danger-soft"],
      link: buttonRecipe.look.link,
    },
    size: {
      default: buttonRecipe.size.default,
      xs: buttonRecipe.size.xs,
      sm: buttonRecipe.size.sm,
      lg: buttonRecipe.size.lg,
      icon: buttonRecipe.size.icon,
      "icon-xs": buttonRecipe.size["icon-xs"],
      "icon-sm": buttonRecipe.size["icon-sm"],
      "icon-lg": buttonRecipe.size["icon-lg"],
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

function Button({
  className,
  variant = "default",
  size = "default",
  ...props
}: ButtonPrimitive.Props & VariantProps<typeof buttonVariants>) {
  return (
    <ButtonPrimitive
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Button, buttonVariants };
